/**
 * Programs & Events Translations Module (Japanese)
 * @module programs
 * @language ja
 */

export const programs = {
  programsEventsPage: {
    pageSubtitle: "JCI RISE • CYE • JIB • ディベート • パブリックスピーキング • 2024-2025年カンファレンス"
  },
  programs: {
    flagshipPrograms: "フラッグシッププログラム",
    programDataMetrics: "JCIインパクトレポート2025からの実際のインパクトデータ",
    coreInitiative: "コアイニシアチブ",
    jciRise: "JCI RISE",
    riseQuote: "コミュニティの再建、行動の鼓舞、インパクトの持続、若者のエンパワーメント",
    totalProjects: "総プロジェクト",
    beneficiaries: "受益者",
    volunteerHours: "ボランティア時間",
    localOrganizations: "ローカル組織",
    countries: "国",
    projects: "プロジェクト",
    economicRecovery: "経済回復",
    workforceReadiness: "労働力準備",
    mentalHealth: "メンタルヘルス",
    shareOfRiseProjects: "RISEプロジェクトのシェア",
    focusAreas: "フォーカスエリア",
    keyInitiatives: "主要イニシアチブ",
    fiiWeight: "FII重み",
    smeSupport: "中小企業支援、マイクロファイナンス、市場アクセス",
    skillsTraining: "スキルトレーニング、雇用プログラム",
    awarenessSupport: "啓発キャンペーン、サポートサービス",
    // RISE Economic Recovery Initiatives
    businessTraining: "ビジネストレーニング",
    microfinanceLinkage: "マイクロファイナンス連携",
    marketAccess: "市場アクセス",
    // RISE Workforce Initiatives
    stemTraining: "STEMトレーニング",
    digitalSkills: "デジタルスキル",
    apprenticeships: "見習い制度",
    // RISE Mental Health Initiatives
    supportGroups: "サポートグループ",
    schoolWellnessPrograms: "学校ウェルネスプログラム",
    hotlines: "ホットライン",
    // FII Weight Labels
    entrepreneurship: "起業家精神",
    workforce: "労働力",
    mentalHealthWeight: "メンタルヘルス",
    regionalProjectDistribution: "地域別プロジェクト分布",
    largestVolume: "最大ボリューム",
    rapidGrowth: "急速な成長",
    consolidating: "統合中",
    qualityFocus: "品質フォーカス",
    strategicOpportunity: "戦略的機会",
    strategicOpportunityText: "アメリカとヨーロッパはプロジェクトの11%のみですが、RISE向けの強力なインフラを持っています。ターゲット拡大を検討してください。",
    sdgAlignmentMatrix: "SDGアラインメントマトリックス",
    sdgsAddressed: "12のSDGsに対応",
    riseProjectsAddress: "RISEプロジェクトは国連の17のSDGsのうち12に対応",
    primaryFocusAreas: "主要フォーカスエリア",
    allSdgsCoverage: "全SDGsカバレッジ",
    primaryFocus: "主要フォーカス",
    crossCutting: "横断的",
    sizeProjectCount: "プロジェクト数",
    resourcesMobilized: "動員されたリソース",
    total: "合計",
    totalResourceMobilization: "総リソース動員",
    estimatedValue: "推定経済価値",
    resourceBreakdown: "リソース内訳",
    volunteer: "ボランティア価値",
    volunteerHoursValue: "ボランティア時間の価値",
    corporate: "企業パートナー",
    corporatePartnerships: "企業パートナーシップ",
    grantsFoundations: "助成金と財団",
    hoursAtStandardRate: "435,605時間（標準レート）",
    hoursAtStandardRates: "標準レートでの時間",
    globalCorporatePar: "グローバル企業パートナーシップ",
    globalCorporatePartners: "グローバル企業パートナー",
    foundationSupport: "財団と助成金サポート",
    efficiencyMetrics: "効率メトリクス",
    costPerBeneficiary: "受益者あたりのコスト",
    volunteerROI: "ボランティアROI",
    partnerRetention: "パートナー維持率",
    highlyEfficient: "高効率",
    forEveryDollar: "1ドルあたり",
    yearOverYear: "前年比",
    virtualEvent: "バーチャルイベント",
    globalYouthDialogue: "グローバルユースダイアログ",
    dialogueDate: "2025年9月24日",
    theme: "テーマ",
    youthLeadershipUncertainty: "不確実な時代の若者リーダーシップ",
    globalYouthLeaders: "グローバルユースリーダー",
    continents: "大陸",
    registrants: "登録者",
    liveAttendees: "ライブ参加者",
    fbLiveViewers: "FBライブ視聴者",
    totalReach: "総リーチ",
    comments: "コメント",
    shares: "シェア",
    reactions: "リアクション",
    eventOutcomes: "イベント成果",
    leadershipTrainingHours: "リーダーシップトレーニング時間",
    certificatesIssued: "発行された証明書",
    businessPartnerships: "ビジネスパートナーシップ",
    mentorshipRelationships: "メンターシップ関係",
    riseProjectsCommissioned: "委託されたRISEプロジェクト",
    mediaImpressions: "メディアインプレッション",
    genderDistribution: "性別分布",
    male: "男性",
    female: "女性",
    nonBinary: "ノンバイナリー",
    attendanceType: "参加タイプ",
    events20242025: "2024-2025年イベント",
    repeatAttendees: "リピート参加者",
    firstTime: "初参加",
    firstTimeRecruitment: "重要な採用機会！",
    conferencesMap: "カンファレンスマップ",
    areaConferencesWorldCongress: "エリアカンファレンス＆ワールドコングレス",
    events: "イベント",
    resetView: "ビューをリセット",
    worldCongress: "ワールドコングレス",
    areaConference: "エリアカンファレンス",
    expected: "予定",
    openInGoogleMaps: "Googleマップで開く",
    participants: "参加者",
    teams: "チーム",
    prizeMoney: "賞金",
    largest: "最大",
    top: "トップ",
    impact: "インパクト",
    winnerProfile: "受賞者プロフィール",
    averageAge: "平均年齢",
    femaleFounders: "女性創業者",
    participationByConference: "カンファレンス別参加",
    curriculumAreas: "カリキュラムエリア",
    outcomes: "成果",
    partnerNetwork: "パートナーネットワーク",
    new: "新規",
    learnMore: "もっと見る",
    lessDetails: "詳細を非表示"
  },
  programDetailData: {
    cyeObjective: "イノベーション競争を通じて若い起業家を育成",
    cyeImpact1: "20か国以上から108人の起業家が競争",
    cyeImpact2: "1万ドル以上の賞金が授与",
    cyeImpact3: "参加者の35%が女性創業者",
    cyeImpact4: "40%がテック分野、産業の多様化",
    cyeImpact5: "メンターシップとネットワーキングの機会を確立",
    services: "サービス",
    other: "その他",
    cyeGeography: "4つのJCIエリア全体にグローバル分布",
    cyeFiiAlignment: "FIIの経済回復と起業家精神の次元をサポート",
    jibObjective: "プロフェッショナル開発とビジネスネットワーキング",
    jibCurriculum1: "ビジネスイノベーション＆戦略",
    jibCurriculum2: "財務管理",
    jibCurriculum3: "グローバル市場アクセス",
    jibCurriculum4: "リーダーシップの卓越性",
    jibCurriculum5: "ビジネスにおけるメンタルヘルス",
    jibOutcome1: "ビジネススキルの向上を報告",
    jibOutcome2: "プロフェッショナルネットワークを拡大",
    jibOutcome3: "新しいビジネスイニシアチブを開始",
    jibOutcome4: "リーダーシップへの自信が向上",
    jibOutcome5: "メンタルウェルネス実践を適用",
    growingRapidly: "急速に成長中",
    globalMentors: "グローバルメンター",
    angelInvestors: "エンジェル投資家",
    vcNetworks: "VCネットワーク",
    jibFiiAlignment: "FIIの労働力と経済の次元にアラインメント",
    fiiAlignment: "FIIアラインメント",
    publicSpeakingName: "パブリックスピーキング競争",
    publicSpeakingObjective: "自信とコミュニケーションの卓越性を開発",
    psTopic1: "若者と気候行動",
    psTopic2: "不確実性におけるリーダーシップ",
    psTopic3: "デジタル変革のインパクト",
    psTopic4: "コミュニティレジリエンスの構築",
    psSkill1: "言語コミュニケーション",
    psSkill2: "批判的思考",
    psSkill3: "自信の構築",
    psSkill4: "異文化認識",
    psSkill5: "リーダーシッププレゼンス",
    reportIncreasedConfidence: "自信の増加を報告",
    equalParticipation: "均等参加",
    psFiiAlignment: "コミュニケーションスキルを通じて労働力準備を強化",
    competitionTopics: "競争トピック",
    skillFocusAreas: "スキルフォーカスエリア",
    skillDevelopment: "スキル開発",
    competitionFormat: "競争フォーマット",
    languageDistribution: "言語分布",
    debatingName: "ディベート選手権",
    debatingObjective: "批判的思考を促進する多言語ディベート競争",
    english: "英語",
    french: "フランス語",
    spanish: "スペイン語",
    debateSkill1: "分析的推論",
    debateSkill2: "構造化された議論",
    debateSkill3: "リサーチスキル",
    debateSkill4: "グローバル認識",
    debateSkill5: "学術的卓越性",
    debateFormat: "ワールドスクールズディベート形式",
    debateFiiAlignment: "労働力準備のための批判的思考を開発",
    debateImpact1: "分析的思考の強化",
    debateImpact2: "パブリックスピーキングの向上",
    debateImpact3: "リサーチ方法論スキル",
    debateImpact4: "異文化理解"
  },
  sdgs: {
    noPoverty: "貧困をなくそう",
    zeroHunger: "飢餓をゼロに",
    goodHealth: "健康と福祉",
    qualityEducation: "質の高い教育",
    genderEquality: "ジェンダー平等",
    cleanWater: "安全な水とトイレ",
    affordableEnergy: "エネルギーをみんなに",
    decentWork: "働きがいのある人間らしい仕事と経済成長",
    industryInnovation: "産業と技術革新の基盤",
    reducedInequalities: "不平等の削減",
    sustainableCities: "住み続けられるまちづくり",
    responsibleConsumption: "つくる責任つかう責任",
    climateAction: "気候変動対策",
    lifeBelowWater: "海の豊かさを守ろう",
    lifeOnLand: "陸の豊かさも守ろう",
    peaceJustice: "平和と公正をすべての人に",
    partnerships: "パートナーシップで目標を達成"
  },
  programsShowcase: {
    title: "フラッグシッププログラムとイベント",
    subtitle: "JCIインパクトレポート2025からの実際のインパクトデータ",
    coreInitiative: "コアイニシアチブ",
    riseDesc: "コミュニティの再建、鼓舞、持続、エンパワーメント",
    projects: "プロジェクト",
    beneficiaries: "受益者",
    volunteerHours: "ボランティア時間",
    risePillarsDistribution: "RISEピラー分布",
    economicRecovery: "経済回復",
    workforceReadiness: "労働力準備",
    mentalHealth: "メンタルヘルス",
    cye: "Creative Young Entrepreneur (CYE)",
    cyeDesc: "地域起業家精神競争",
    jib: "JCI in Business (JIB)",
    jibDesc: "ビジネスネットワーキングと開発プログラム",
    publicSpeaking: "パブリックスピーキング競争",
    publicSpeakingDesc: "自信とコミュニケーションスキルを開発",
    debating: "ディベート選手権",
    debatingDesc: "多言語ディベート競争",
    english: "英語",
    french: "フランス語",
    spanish: "スペイン語",
    totalParticipants: "総参加者",
    totalTeams: "総チーム",
    prize: "賞金",
    teams: "チーム",
    areaConferences2025: "2025年エリアカンファレンス",
    asiaPacificConference: "アジアと太平洋カンファレンス",
    europeConference: "ヨーロッパカンファレンス",
    africaMeConference: "アフリカ・中東カンファレンス",
    americasConference: "アメリカカンファレンス",
    attendees: "参加者",
    firstTimers: "初参加者",
    featuredEvent: "注目イベント",
    globalYouthDialogue: "グローバルユースダイアログ2025",
    registrants: "登録者",
    liveAttendees: "ライブ参加者",
    fbLiveViewers: "FBライブ視聴者",
    chatMessages: "チャットメッセージ",
    jciSenators: "JCIセネター",
    senatorsNew: "2025年84人新規",
    toypRecognized: "TOYP認識",
    toypCategories: "10カテゴリー",
    peopleImpacted: "インパクトを受けた人々",
    throughAllPrograms: "すべてのプログラムを通じて",
    sourceNote: "出典：JCIインパクトレポート2025 - 公式プログラムおよびイベントデータ"
  },
  sdgAlignment: {
    title: "SDGアラインメント",
    subtitle: "国連持続可能な開発目標にマッピングされたJCIプログラム",
    sdgCount: "対象SDGs",
    sdgCountDesc: "JCIプログラムは17のUN SDGsのうち12に貢献",
    primaryGoals: "主要目標",
    primaryGoalsDesc: "JCIイニシアチブによって最も影響を受ける",
    goodHealth: "健康と福祉",
    qualityEducation: "質の高い教育",
    decentWork: "働きがいのある人間らしい仕事と経済成長",
    reducedInequalities: "不平等の削減",
    partnerships: "目標達成のためのパートナーシップ",
    impactMapping: "インパクトマッピング",
    riseProjects: "RISEプロジェクト",
    riseProjectsDesc: "メンタルヘルス、労働力、経済回復にアラインメント",
    cyeProgram: "CYEプログラム",
    cyeDesc: "起業家精神とイノベーションをサポート",
    jibProgram: "JIBプログラム",
    jibDesc: "ビジネススキルとプロフェッショナルネットワークを育成",
    toyp: "TOYP",
    toypDesc: "若者のリーダーシップとインパクトを認識",
    sourceNote: "出典：JCIインパクトレポート2025 - SDGアラインメント方法論"
  },
  impactMetricsTitle: "インパクトメトリクス",
  impactMetricsSubtitle: "JCIのグローバルリーチとコミュニティインパクトの測定",
  riseTitle: "RISEイニシアチブ",
  riseSubtitle: "コミュニティの再建、鼓舞、持続、エンパワーメント",
  cyeTitle: "Creative Young Entrepreneurs (CYE)",
  cyeSubtitle: "地域起業家精神競争",
  jibTitle: "JCI in Business (JIB)",
  jibSubtitle: "ビジネスネットワーキングとプロフェッショナル開発",
  debatingTitle: "ディベート選手権",
  debatingSubtitle: "批判的思考を育成する多言語ディベート競争",
  publicSpeakingTitle: "パブリックスピーキング競争",
  publicSpeakingSubtitle: "自信とコミュニケーションの卓越性を構築",
  conferencesTitle: "エリアカンファレンス",
  conferencesSubtitle: "ネットワーキングとトレーニングのための年次地域集会",
  rise: {
    title: "JCI RISEイニシアチブ",
    subtitle: "コミュニティの再建、鼓舞、持続、エンパワーメント",
    totalProjects: "総RISEプロジェクト",
    beneficiariesReached: "リーチした受益者",
    volunteerHours: "ボランティア時間",
    budgetMobilized: "動員された予算",
    pillarDistribution: "ピラー分布",
    mentalHealth: "メンタルヘルス",
    workforceReadiness: "労働力準備",
    economicRecovery: "経済回復",
    regionalBreakdown: "地域別内訳",
    projectsByRegion: "地域別プロジェクト",
    topProjects: "インパクト別トップRISEプロジェクト",
    viewFullReport: "完全なRISEレポートを見る"
  },
  cye: {
    title: "Creative Young Entrepreneurs (CYE)",
    subtitle: "イノベーションを育成する地域起業家精神競争",
    participants: "総参加者",
    teams: "総チーム",
    prizePool: "総賞金プール",
    winnersTitle: "2024年受賞者",
    categories: "競争カテゴリー",
    socialEnterprise: "ソーシャルエンタープライズ",
    techInnovation: "テクノロジーとイノベーション",
    greenBusiness: "グリーンビジネス",
    traditionalBusiness: "伝統的ビジネス",
    impactMetrics: "インパクトメトリクス",
    businessesLaunched: "立ち上げられたビジネス",
    jobsCreated: "創出された雇用",
    fundingSecured: "確保された資金"
  },
  jib: {
    title: "JCI in Business (JIB)",
    subtitle: "プロフェッショナル開発とビジネスネットワーキングプログラム",
    activeMembers: "アクティブJIB会員",
    networkingEvents: "ネットワーキングイベント",
    businessPartnerships: "ビジネスパートナーシップ",
    benefits: "JIBベネフィット",
    professionalNetwork: "プロフェッショナルネットワークアクセス",
    businessSkills: "ビジネススキル開発",
    mentorship: "メンターシップ機会",
    careerAdvancement: "キャリア進歩サポート",
    focusAreas: "フォーカスエリア",
    leadership: "リーダーシップ開発",
    networking: "ビジネスネットワーキング",
    skills: "プロフェッショナルスキル",
    entrepreneurship: "起業家精神サポート"
  },
  debating: {
    title: "JCIディベート選手権",
    subtitle: "批判的思考を促進する多言語ディベート競争",
    totalTeams: "総チーム",
    languages: "言語",
    countries: "参加国",
    format: "競争形式",
    preliminaryRounds: "予選ラウンド",
    semifinals: "準決勝",
    grandFinal: "グランドファイナル",
    skillsDeveloped: "開発されたスキル",
    criticalThinking: "批判的思考",
    publicSpeaking: "パブリックスピーキング",
    research: "リサーチと分析",
    teamwork: "チームワークとコラボレーション",
    recentChampions: "最近のチャンピオン",
    viewHighlights: "ディベートハイライトを見る"
  },
  publicSpeaking: {
    title: "パブリックスピーキング競争",
    subtitle: "自信とコミュニケーションの卓越性を構築",
    participants: "総参加者",
    countries: "参加国",
    speechTopics: "スピーチトピック",
    improvisation: "即興スピーキング",
    prepared: "準備されたスピーチ",
    persuasive: "説得的スピーチ",
    competencies: "評価される能力",
    delivery: "デリバリーとプレゼンス",
    content: "コンテンツと構造",
    impact: "インパクトと説得",
    languageProficiency: "言語能力",
    recentWinners: "最近の受賞者",
    watchSpeeches: "受賞スピーチを見る"
  },
  conferences: {
    title: "JCIエリアカンファレンス",
    subtitle: "ネットワーキング、トレーニング、リーダーシップのための年次地域集会",
    totalAttendees: "総参加者（2025年）",
    conferences: "カンファレンス",
    firstTimers: "初参加者",
    countries: "代表国",
    conferenceHighlights: "カンファレンスハイライト",
    keynotes: "基調講演者",
    workshops: "トレーニングワークショップ",
    networking: "ネットワーキングセッション",
    awards: "賞と認識",
    upcomingConferences: "2025年予定カンファレンス",
    registerNow: "今すぐ登録",
    viewSchedule: "スケジュールを見る"
  },
  toyp: {
    title: "Ten Outstanding Young Persons (TOYP)",
    subtitle: "世界中の優れた若いリーダーを認識",
    recognizedLeaders: "認識されたリーダー（2025年）",
    categories: "賞カテゴリー",
    nominationsOpen: "指名期間",
    categoryList: {
      businessEconomic: "ビジネスと経済的達成",
      humanitarian: "人道的および自発的サービス",
      science: "学術的リーダーシップと達成",
      political: "政治的、法的、政府的問題",
      cultural: "文化的達成",
      medical: "医学イノベーション",
      environmental: "環境リーダーシップ",
      world: "世界平和と人権",
      children: "児童福祉と教育",
      personal: "個人的改善と達成"
    },
    selectionProcess: "選考プロセス",
    nomination: "指名",
    evaluation: "評価",
    recognition: "認識",
    pastHonorées: "過去のTOYP受賞者",
    submitNomination: "指名を提出"
  },
  programMetrics: {
    title: "プログラム参加メトリクス",
    subtitle: "JCIプログラム全体でのメンバーエンゲージメント",
    totalParticipants: "総プログラム参加者",
    programReach: "地域別プログラムリーチ",
    growthTrend: "前年比成長",
    satisfactionScore: "参加者満足度",
    highRating: "高評価",
    repeatParticipation: "リピート参加",
    likelyToRecommend: "推薦する可能性",
    topPerformingPrograms: "トップパフォーミングプログラム",
    program: "プログラム",
    participants: "参加者",
    satisfaction: "満足度",
    growth: "成長"
  },
  programImpact: {
    title: "プログラムインパクト評価",
    subtitle: "成果と長期的インパクトの測定",
    skillsDevelopment: "スキル開発",
    reportImprovedSkills: "リーダーシップスキルの向上を報告",
    networkGrowth: "ネットワーク成長",
    expandedNetwork: "プロフェッショナルネットワークを拡大",
    careerAdvancement: "キャリアアドバンスメント",
    careerProgress: "キャリアの進歩をJCIに帰属",
    communityImpact: "コミュニティインパクト",
    ledCommunityProjects: "コミュニティプロジェクトを主導または参加",
    impactStories: "インパクトストーリー",
    readStories: "メンバーストーリーを読む",
    shareYourStory: "あなたのストーリーを共有"
  },
  humanDuties: {
    title: "国際人間義務イニシアチブ",
    headline: "倫理的リーダーシップのための67,101のグローバルな声",
    heroDescription: "国際人間義務イニシアチブは、グローバルなリーダーシップ論の重要な転換点を表しています。人権は広く認識されていますが、その補完的な概念である人間の義務—権利に伴う責任—はまだ十分に探求されていません。JCIはリーダーのための人間義務の世界宣言を通じてこの会話を主導しています。",
    totalPetitions: "署名された請願書の総数",
    globalSignatories: "グローバル署名者",
    geographicCoverage: "地理的カバレッジ",
    countriesAcross: "4つの地域の国々",
    nationalAmbassadors: "ナショナルアンバサダー",
    leadingCoordination: "IHDD調整を主導",
    regionalBreakdown: "地域別内訳",
    region: "地域",
    petitionsSigned: "署名された請願書",
    percentGlobal: "グローバルの%",
    asiaPacific: "アジアと太平洋",
    africaMiddleEast: "アフリカ・中東",
    americas: "アメリカ",
    europe: "ヨーロッパ",
    highMomentum: "高い勢い",
    growingActivities: "成長中（19活動）",
    establishedBase: "確立された基盤",
    emerging: "新興",
    keyMilestones: "主要な制度的マイルストーン",
    nelsonMandelaEndorsement: "ネルソン・マンデラ財団の承認",
    mandelaDesc: "人間義務イニシアチブの公式認定（2025年）",
    legislativeSuccess: "立法上の成功",
    legislativeDesc: "スリア州（ベネズエラ）が人間義務法を制定、7月10日を国際人間義務の日と宣言（2025年）",
    ihddImpact: "国際人間義務の日（IHDD）の影響",
    reportedActivities: "2025年報告活動",
    sevenDutiesFramework: "リーダーのための7つの義務",
    duty1: "人間の尊厳を守る義務",
    duty2: "公益に奉仕する義務",
    duty3: "環境を保護する義務",
    duty4: "公平と正義を促進する義務",
    duty5: "平和と理解を育む義務",
    duty6: "教育と発展を支援する義務",
    duty7: "誠実さと説明責任をもって行動する義務",
    ctaTitle: "ムーブメントに参加",
    signPetition: "請願書に署名",
    becomeAmbassador: "ナショナルアンバサダーになる",
    viewStories: "IHDDストーリーを見る",
    sourceNote: "出典：JCIインパクトレポート2025 – 人間義務イニシアチブデータ"
  },
  strategicPartnerships: {
    title: "戦略的グローバルパートナーシップ",
    headline: "橋を架ける：JCIの戦略的グローバルパートナーシップ",
    heroDescription: "JCIの影響力は、若いリーダーの育成と持続可能な開発の推進へのコミットメントを共有するグローバル組織との戦略的パートナーシップを通じて増幅されます。",
    activePartnership: "アクティブなパートナーシップ",
    growingPartnership: "成長中のパートナーシップ",
    emergingPartnership: "新興パートナーシップ",
    infrastructurePartner: "インフラパートナー",
    partnershipTiers: "パートナーシップティア",
    tier1Active: "ティア1：アクティブパートナーシップ",
    tier2Growing: "ティア2：成長中のパートナーシップ",
    tier3Emerging: "ティア3：新興パートナーシップ",
    tier4Infrastructure: "ティア4：インフラパートナー",
    roiIndicators: "パートナーシップROI指標",
    partner: "パートナー",
    memberBenefit: "メンバーベネフィット",
    orgBenefit: "組織的ベネフィット",
    effortLevel: "努力レベル",
    roiTimeline: "ROIタイムライン",
    low: "低",
    medium: "中",
    veryLow: "非常に低い",
    immediate: "即時",
    threeMonths: "3ヶ月",
    sixMonths: "6ヶ月",
    oneYear: "1年",
    iccName: "国際商業会議所（ICC）",
    unName: "国際連合（UN）",
    unescoName: "UNESCO",
    worldBankName: "世界銀行 / IFC",
    wefName: "世界経済フォーラム（WEF）",
    aiesecName: "AIESEC",
    bniName: "BNI（Business Network International）",
    wbafName: "女性ビジネスアライアンスフォーラム（WBAF）",
    zohoName: "Zoho",
    gyefName: "グローバルユース経済フォーラム（GYEF）",
    ctaTitle: "パートナーネットワークに参加",
    viewAllPartnerships: "すべてのパートナーシップを見る",
    partnerWithJCI: "JCIとパートナーシップ",
    accessResources: "パートナーリソースにアクセス",
    sourceNote: "出典：JCIインパクトレポート2025 – 戦略的パートナーシップ"
  }
} as const;
